import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import {
  useCreateGoalsMutation,
  useUpdateGoalsMutation,
} from "../../../../hooks/api/mutations/usePerformance";
import { ToastContext } from "../../../../hooks/context";
import { extractDateOnly } from "../../../../helpers";
import { useQueryClient } from "react-query";

export const useGoalsForm = ({
  goalDetails = {},
  isEditMode = false,
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const [goalsForm, setGoalsForm] = useState({
    name: goalDetails?.name || "",
    store_ids: goalDetails?.stores?.map((store) => `${store?.id}`) || [],
    start_date: goalDetails?.start_date
      ? extractDateOnly(goalDetails?.start_date)
      : "",
    end_date: goalDetails?.end_date
      ? extractDateOnly(goalDetails?.end_date)
      : "",
    target_amount: goalDetails?.target_amount || "",
    notes: goalDetails?.notes || "",
    include_refund_in_calc: goalDetails?.include_refund_in_calc || false,
    type: "grossRevenue",
  });

  const { isLoading: isCreatingGoals, mutate: createGoals } =
    useCreateGoalsMutation();

  const { isLoading: isUpdatingGoals, mutate: updateGoals } =
    useUpdateGoalsMutation();

  const handleCreateOrUpdateGoals = () => {
    if (!isEditMode)
      createGoals(goalsForm, {
        onSuccess: () => {
          triggerToast("Goals started successfully", "success");
          closeModal();
        },
      });
    else
      updateGoals(
        { id: goalDetails?.id, data: goalsForm },
        {
          onSuccess: () => {
            triggerToast("Goals updated successfully", "success");
            queryClient.invalidateQueries([
              "getGoalsDetails",
              `${goalDetails?.id}`,
            ]);
            closeModal();
          },
        },
      );
  };

  return {
    isCreatingGoals: isCreatingGoals || isUpdatingGoals,
    goalsForm,
    storeList,
    setGoalsForm,
    handleCreateOrUpdateGoals,
  };
};
